module.exports = __webpack_public_path__ + "static/media/Balon6Meses_BN_blur.90f66386.jpg";